import { Star, User } from 'lucide-react';
import { useState, useEffect } from 'react';

interface TestimonialCardProps {
  name: string;
  role: string;
  image: string;
  quote: string;
  rating: number;
  metric: string;
}

export default function TestimonialCard({ name, role, image, quote, rating, metric }: TestimonialCardProps) {
  const [imageError, setImageError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = image;
    img.onload = () => setImageLoaded(true);
    img.onerror = () => setImageError(true);
  }, [image]);

  return (
    <div className="backdrop-blur-lg bg-white/5 rounded-lg p-6 border border-white/10 transition-all duration-300 hover:bg-white/10">
      <div className="flex items-center mb-4">
        {imageError || !imageLoaded ? (
          <div className="w-14 h-14 rounded-full bg-white/10 flex items-center justify-center mr-4">
            <User className="w-7 h-7 text-gray-400" />
          </div>
        ) : (
          <img
            src={image}
            alt={name}
            className="w-14 h-14 rounded-full object-cover mr-4 border-2 border-white/10"
            loading="eager"
            onError={() => setImageError(true)}
          />
        )}
        <div>
          <h3 className="font-semibold">{name}</h3>
          <p className="text-sm text-gray-400">{role}</p>
        </div>
      </div>
      
      <div className="flex mb-2">
        {Array.from({ length: rating }).map((_, i) => (
          <Star key={i} className="w-4 h-4 fill-[#03c8ff] text-[#03c8ff]" />
        ))}
      </div>
      
      <blockquote className="text-gray-300 mb-4">"{quote}"</blockquote>
      
      <div className="inline-block px-3 py-1 bg-[#03c8ff]/10 text-[#03c8ff] text-sm rounded-full">
        {metric}
      </div>
    </div>
  );
}